import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { TableDropDown } from "@solsys/solsys-reactjs";
import { useUserList } from "../contexts/UserListContext";

const NotificationDropDown = ({ selected, ...props }) => {
  selected = selected === -1 ? undefined : selected;
  const [renderList, setRenderList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [renderLoading, setRenderLoading] = useState(true);
  const [selectedIds, setSelectedIds] = useState([]);

  const userList = useUserList();

  const truncateLength = 25;

  const [requestState, setRequestState] = useState({
    page: 1,
    pageSize: 20,
    search: "",
  });
  const { page, pageSize, search } = requestState;

  const filtered = useMemo(
    () => (userList ?? []).filter((user) => user.name.includes(search)),
    [userList, search]
  );

  const end = Math.min(page * pageSize, filtered.length);
  const filterList = filtered.slice(0, end);

  const totalCountRef = useRef(0);
  totalCountRef.current = filtered.length;
  const accumulatedLenRef = useRef(0);
  accumulatedLenRef.current = filterList.length;

  useEffect(() => {
    if (userList) {
      setLoading(false);
    }
  }, [userList]);

  useEffect(() => {
    setRequestState((s) => ({ ...s, page: 1 }));
  }, [search]);

  useEffect(() => {
    if (userList) {
      const renderData = userList.filter((user) => selected && Array.isArray(selected) && selected.includes(user.id));
      if (renderData && renderData.length > 0) {
        setRenderList(renderData.map(user => ({
          ...user,
          Name: user.name
        })));
        setSelectedIds(selected);
        setRenderLoading(false);
      } else {
        setRenderList([]);
        setSelectedIds([]);
        setRenderLoading(false);
      }
    }
  }, [selected, userList]);

  const onSearch = (event) => {
    let { value } = event.target;
    setRequestState((s) => ({
      ...s,
      search: value,
      page: 1,
    }));
  };

  const paginationChange = (newPage) => {
    setRequestState((s) => ({
      ...s,
      page: newPage,
    }));
  };

  const addMoreResultsHandler = useCallback(() => {
    if (props.disabled) return;
    setRequestState((s) => {
      if (accumulatedLenRef.current >= totalCountRef.current) return s;
      return { ...s, page: s.page + 1 };
    });
  }, [props.disabled]);

  const entityList = filterList.map(item => ({
    ...item,
    Name: item.name
  }));

  const headers = [
    { label: "Name" }
  ];

  const userCount = filtered.length;

  return (
    <TableDropDown
      { ...props }
      items={ entityList }
      loading={ loading }
      renderLoading={ renderLoading }
      multiple={ props.multiple }
      searchEnabled={ props.searchEnabled }
      searchValue={ search }
      onSearch={ onSearch }
      selectValue={ selectedIds }
      selectRender={ renderList }
      onSelect={ props.onChange || props.onSelect }
      dataKey={ "id" }
      identityColumnKey={ "Name" }
      renderColumnKey={ "Name" }
      headers={ headers }
      truncateLength={ truncateLength }
      entityCount={ userCount }
      onPaginationChange={ paginationChange }
      addMoreResults={
        typeof props.addMoreResults === "function"
          ? props.addMoreResults
          : addMoreResultsHandler
      }
    />
  );
};

export default NotificationDropDown;
